import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import HashLocalStorage from '@sone/sone-frontend-core/src/utils/HashLocalStorage';
import namespacesStore from './namespaces';
import user from '@sone/sone-frontend-core/src/store/modules/user';
import i18n from './modules/i18n';

Vue.use(Vuex);

export const namespaces = namespacesStore;
export default new Vuex.Store<any>({
  state: {
    error: {
      statusCode: 404
    }
  },
  mutations: {
    SET_ERROR: (state, error) => state.error = error
  },
  actions: {
  },
  modules: {
    [namespacesStore.USER]: user,
    [namespacesStore.I18N]: i18n,

  },
  plugins: [
    createPersistedState({
      storage: new HashLocalStorage(),
      reducer: (state) => ({
        [namespacesStore.USER]: state[namespacesStore.USER],
        [namespacesStore.I18N]: state[namespacesStore.I18N],
        oidc: state.oidc,
      })
    })
  ]
});
